import { EventEmitter } from 'events';
import dispatcher from 'dispatcher';
import * as ActionConstants from 'utils/ActionConstants';
import * as CreditConstants from './CreditConstants';
import SessionManager from '../../Managers/SessionManager';

class CreditStore extends EventEmitter {
    constructor() {
        super();
        this.state = SessionManager.getCreditState() || {
            state: CreditConstants.CREDIT_STEP1
        };
    }

    getState() {
        return this.state;
    }
    handleActions(action) {
        console.log('Action', action);
        switch (action.type) {
            case ActionConstants.GO_TO_NEXT_CREDIT_STEP: {
                this.state.state = action.payload.state;
                this.state = Object.assign({}, this.state, action.payload.data);
                console.log('CREDIT STORE::', this.state);
                break;
            }
            case ActionConstants.SEND_CREDIT_APP + '_SUCCESSFUL': {
                this.state = { state: CreditConstants.CREDIT_STEP1 };
                alert(
                    ' Thank you for your credit submission. Stay tuned! We will be contacting you via email or phone in the next 4-6 business hours. Business hours are 7:30am – 4pm EST.'
                );
                break;
            }
            case ActionConstants.SEND_CREDIT_APP + '_FAILURE': {
                alert('Error sending quote');
                break;
            }
        }
        SessionManager.setCreditState(this.state);
        this.emit('change');
    }
}
const creditStore = new CreditStore();

dispatcher.register(creditStore.handleActions.bind(creditStore));

export default creditStore;



// WEBPACK FOOTER //
// ./src/app/pages/credit/CreditStore.js